import { useEffect, useState } from 'react'

import type { User } from 'src/app/types'

export type UseAuthParams = {
  parentAppUser?: User
}

const useAuth = ({ parentAppUser }: UseAuthParams = {}): Record<string, any> => {
  const [user, setUser] = useState<User | undefined>(parentAppUser)
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(Boolean(parentAppUser?.token))

  useEffect(() => {
    const authenticate = async (): Promise<void> => {
      const { AuthService } = await import('src/lib/services/auth')
      AuthService.casSignInRedirect()
    }

    const listenToAuthentication = async (): Promise<void> => {
      const { AuthService } = await import('src/lib/services/auth')
      AuthService.subscribe((user) => {
        if (user) {
          setIsLoggedIn(true)
          setUser({
            id: user.profile.id,
            token: user.id_token,
            name: user.profile.name || '',
            email: user.profile.email || '',
            ucode: user.profile.ucode || '',
            authorities: user.profile.authorities
          })
        }
      })
    }

    if (process.env.IS_CAS === 'true') {
      listenToAuthentication()
      authenticate()
    }
  }, [])

  useEffect(() => {
    const logTokenChange = (): void => {
      if (process.env.TARGET_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('token changes: ', { token: user?.token, parentToken: parentAppUser?.token })
      }
    }

    const updateToken = (): void => {
      if (process.env.IS_CAS === 'false' && user?.token !== parentAppUser?.token) {
        logTokenChange()
        setUser(parentAppUser)
      }
    }

    updateToken()
  }, [parentAppUser, user?.token])

  return { isLoggedIn, user }
}

export default useAuth
